import React, { Fragment } from "react";
import { View, Text, StyleSheet } from "@react-pdf/renderer";
const ExpenseTableHeader = () => {
  const styles = StyleSheet.create({
    Flightcontainer: {
      flexDirection: "row",
      backgroundColor: "#E4E4E4",
      alignItems: "center",
      fontStyle: "bold",
      paddingBottom: "5px",
      paddingTop: "10px",
      paddingLeft: "15px",
    },
    one: {
      width: "10%",
      fontSize: "11px",
      color: "#333333",
    },
    two: {
      width: "20%",
      fontSize: "11px",
      color: "#333333",
    },
    three: {
      width: "20%",
      fontSize: "11px",
      color: "#333333",
    },
    four: {
      width: "20%",
      fontSize: "11px",
      color: "#333333",
    },
    five: {
      width: "15%",
      fontSize: "11px",
      color: "#333333",
    },
    six: {
      width: "15%",
      fontSize: "11px",
      color: "#333333",
    },
  });
  return (
    <Fragment>
      <View style={styles.Flightcontainer}>
        <Text style={styles.one}>Ex-ID</Text>
        <Text style={styles.two}>Date - Time</Text>
        <Text style={styles.three}>Merchant</Text>
        <Text style={styles.four}>Category</Text>
        <Text style={styles.five}>Payment Method</Text>
        <Text style={styles.six}>Amount</Text>
      </View>
    </Fragment>
  );
};

export default ExpenseTableHeader;
